import { action } from '@sas/nova-commons/action';
import { BIRDModelController, PositionedModelOwnerController } from '@sas-dvr/ltjs-bird';

const AT = {
  AddLayoutRoot: 'vasdk/epic/addLayoutRoot',
  RemoveLayoutRoot: 'vasdk/epic/removeLayoutRoot',
  LoadBirdModel: 'vasdk/epic/loadBirdModel',
  UnloadBirdModel: 'vasdk/epic/unloadBirdModel',
} as const;

export const EpicActions = {
  actions: {
    addLayoutRoot: (controller: PositionedModelOwnerController, keyToPosition?: string) =>
      action(AT.AddLayoutRoot, { controller, keyToPosition }),
    removeLayoutRoot: (controller: PositionedModelOwnerController) =>
      action(AT.RemoveLayoutRoot, controller),
    loadBirdModel: (controller: BIRDModelController) => action(AT.LoadBirdModel, controller),
    unloadBirdModel: (controller: BIRDModelController) => {
      return action(AT.UnloadBirdModel, controller);
    },
  },
  actionTypes: AT,
};
